import dayjs from 'dayjs';
import { EventRowItem } from 'pages/Agenda/components/EventRowItem';
import { Event } from 'types/Event';

export interface EventListViewProps {
  events: any[];
  onEventSelect?: (item: Event) => void;
}

export const EventListView = ({ events, onEventSelect }: EventListViewProps) => {
  // Grouper les événements par date
  const sortedEvents = events.sort(
    (a: Event, b: Event) => dayjs(a.start).valueOf() - dayjs(b.start).valueOf()
  );
  const groupedEvents = sortedEvents.reduce(
    (
      acc: { [key: string]: any[] },
      event: { start: string | number | Date | dayjs.Dayjs | null | undefined }
    ) => {
      const dateKey = dayjs(event.start).format('YYYY-MM-DD');
      if (!acc[dateKey]) {
        acc[dateKey] = [];
      }
      acc[dateKey].push(event);
      return acc;
    },
    {}
  );

  // Trier les dates
  const sortedDates = Object.keys(groupedEvents).sort();

  return (
    <div className="flex flex-col gap-1 p-4">
      {sortedDates.map((dateKey) => {
        const dayEvents = groupedEvents[dateKey];

        return dayEvents.map((event: Event, index: number) => {
          const currentEventGeneralIndex = sortedEvents.findIndex((e) => e.id === event.id);
          return (
            <EventRowItem
              key={`${dateKey}-${event.id}`}
              item={event}
              showDate={index === 0}
              handleEventSelect={onEventSelect}
              outlined={dayjs(event.end).isBefore(dayjs())}
              isCurrentOrNextEvent={
                dayjs(event.end).isAfter(dayjs()) &&
                (currentEventGeneralIndex === 0 ||
                  dayjs(sortedEvents[currentEventGeneralIndex - 1].end).isBefore(dayjs()))
              }
              className={index === 0 ? 'mt-3' : ''}
            />
          );
        });
      })}
      {sortedDates.length === 0 && (
        <div className="text-center text-gray-500 py-8">Aucun rendez-vous prévu</div>
      )}
    </div>
  );
};
